module.exports = __webpack_public_path__ + "static/media/test project10-6-2021_1630318128780.fa05c225.vtt";